
import axios from 'axios';

const sendFileMessage = async (token, contactId, file) => {

  console.log('File recived', file)
    ///First upload the file to the server
  let encodedFileName = encodeURIComponent(file.name);

  console.log('BBBB encodeded file name is: ', encodedFileName)

  const formData = new FormData();
	formData.append('file', file ,encodedFileName);

    // console.log('FORMDATA', formData);
    // console.log('sendFileMessage input file object', file)
    try {
        await axios.post(process.env.REACT_APP_BACKEND_HOST+'/api/v1/upload',formData);
    
    } catch (err) {
        console.error(err);
        throw new Error(err.message); 
    }


  /// Send the file to twilio via backend server

  var data = {
    "token": token,
    "contactId": contactId,
    "file": encodedFileName
  };
  
  const headers = { 
      'Content-Type': 'application/json'
  };

//   console.log(data);
  try {
      let response = await axios.post(process.env.REACT_APP_BACKEND_HOST+'/api/v1/message/send-file-message', data, { headers })
    //   console.log('Response sending file',response);
      if(response.data.status !== 200)
          throw new Error(response.data.message); 
  }catch(err) {
    //   console.log(err);
      throw new Error(err.message); 
  }
    
};

export default sendFileMessage